module.exports = __webpack_public_path__ + "img/store-icon-white.d3cd7a3.svg";